import { GlobalData } from "../../Common/GlobalData";
import { TemplateHelpers } from "../../Common/KendoHelpers";

export class RsLineBlueDotPatterns {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(RsLineBlueDotPatterns.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_IBD_MARKET_SMITH_RS_LINE_BLUE_DOT_PATTERNS,
                }
            },
            height: 915,
            groupable: false,
            pageable: false,
            sortable: true,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '20%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'pivotNote1',
                title: 'PivotNote1',
                width: '15%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n0}',
            }, {
                field: 'stageA',
                title: 'Stage<br>A',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'rsRating',
                title: 'RS<br>Rating',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'newHigh',
                title: 'RS Line<br>New High',
                width: '6%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= newHigh ? "Yes" : "" #',
            }, {
                field: 'dateOfLastBlueDot',
                title: 'Last<br>Blue Dot',
                width: '8%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('dateOfLastBlueDot')),
            }, {
                field: 'dailyWeekly',
                title: 'Daily<br>Weekly',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'numBlueDots',
                title: 'Number<br>BlueDots',
                width: '7%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'month1',
                title: 'Trend<br>Mon1',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month1 ? "Yes" : "" #',
            }, {
                field: 'month1To4',
                title: 'Trend<br>Mon1-4',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month1To4 ? "Yes" : "" #',
            }, {
                field: 'month5',
                title: 'Trend<br>Mon5',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month5 ? "Yes" : "" #',
            }, {
                field: 'month5Wide',
                title: 'Trend<br>Mon5W',
                width: '5%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: '#= month5Wide ? "Yes" : "" #',
            }]
        });
    }
}
